module.exports = __webpack_public_path__ + "static/13-b0803ef36c0334fb384b7618329e2669.png";